import React, { useCallback, useState } from 'react';

import { FiInfo } from 'react-icons/fi';
import { FaCheck } from 'react-icons/fa';

import ModalInfos from './ModalInfos';

import { useNewRefuel } from '../../../../hooks/useNewRefuel';

import {
  Container,
  InputWrapper,
  InputSelect,
  BaseInfoWrapper,
  InfosDetailWrapper,
  InfoDetailWrapper,
  TitleInfoWrapper,
  BaseName,
  BaseAddress,
  TitleDetail,
  DetailInfo,
  Divisor,
  ModalStyled,
  InfosWrapper,
} from './styles';

type BaseItemMobileProps = {
  baseName: string;
  nickName: string;
  address: string;
  isSelected: boolean;
  routeDays?: string;
  supplyWay?: string;
};

const BaseItemMobile: React.FC<BaseItemMobileProps> = ({
  nickName,
  baseName,
  address,
  isSelected,
  routeDays = '',
  supplyWay = '',
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState<'supplyWay' | 'routeDays'>(
    'supplyWay'
  );

  const { addSelectedBase, removeSelectedBase } = useNewRefuel();

  const handleSelectBase = useCallback(() => {
    if (isSelected) {
      return removeSelectedBase(baseName);
    }
    return addSelectedBase(baseName);
  }, [baseName, isSelected, addSelectedBase, removeSelectedBase]);

  return (
    <Container isSelected={isSelected}>
      <InputWrapper>
        <InputSelect isSelected={isSelected} onClick={handleSelectBase}>
          {isSelected && <FaCheck color="#ffff" />}
        </InputSelect>
      </InputWrapper>
      <InfosWrapper>
        <BaseInfoWrapper>
          <BaseName isSelected={isSelected}>{nickName}</BaseName>
          <BaseAddress>{address}</BaseAddress>
        </BaseInfoWrapper>
        <Divisor />
        <InfosDetailWrapper>
          <InfoDetailWrapper>
            <TitleInfoWrapper>
              <TitleDetail isSelected={isSelected}>
                Forma de abastecimento
              </TitleDetail>
              <FiInfo
                size={12}
                color="#0B29FB"
                onClick={() => {
                  setModalType('supplyWay');
                  setShowModal(true);
                }}
              />
            </TitleInfoWrapper>
            <DetailInfo isSelected={isSelected}>{supplyWay}</DetailInfo>
          </InfoDetailWrapper>
          <InfoDetailWrapper>
            <TitleInfoWrapper>
              <TitleDetail isSelected={isSelected}>Dias de rota</TitleDetail>
              <FiInfo
                size={12}
                color="#0B29FB"
                onClick={() => {
                  setModalType('routeDays');
                  setShowModal(true);
                }}
              />
            </TitleInfoWrapper>
            <DetailInfo isSelected={isSelected}>{routeDays}</DetailInfo>
          </InfoDetailWrapper>
        </InfosDetailWrapper>
      </InfosWrapper>
      <ModalStyled
        show={showModal}
        onHide={() => setShowModal(false)}
        animation={false}
        centered
      >
        <ModalInfos
          closeModal={() => setShowModal(false)}
          isAutomatic={supplyWay === 'Automático'}
          modalType={modalType}
        />
      </ModalStyled>
    </Container>
  );
};

BaseItemMobile.defaultProps = {
  routeDays: '',
  supplyWay: '',
};

export default BaseItemMobile;
